import {useRef, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../../AppToast';

interface ImportExcelProps {

  registerInvoice: any;

  exportExcel(registerInvoiceId: string): Promise<any>;

  exportExcelFileName?: string;

  importExcel(registerInvoiceId: string, data: any): Promise<any>;

  reloadLazyData(): void;
}

export const useDialogImportExcel = (props: ImportExcelProps) => {

  const input = useRef(null);

  const {registerInvoice, exportExcel, exportExcelFileName, importExcel, reloadLazyData} = props;

  const [display, setDisplay] = useState(false);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const showImportDialog = () => {
    setFile(null);
    setDisplay(true);
  }

  const onUploadExcelFile = (event) => {
    if (event && event.target && event.target.files && event.target.files.length) {
      setFile(event.target.files[0]);
    }
  }

  const downloadTemplate = () => {
    if (!submitting && registerInvoice && registerInvoice.id) {
      setSubmitting(true);

      exportExcel(registerInvoice.id).then((data) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `file-mau-${exportExcelFileName}.xlsx`;
        link.click();
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  const handleSubmit = () => {
    if (file && registerInvoice && registerInvoice.id) {
      if (!submitting) {
        setSubmitting(true);

        const formData = new FormData();
        formData.append('files', file);
        importExcel(registerInvoice.id, formData).then(() => {
          setDisplay(false);
          ToastService.success();
          reloadLazyData();
        }).finally(() => {
          setSubmitting(false);
          input.current.value = '';
        });
      }
    } else {
      ToastService.error('Bạn chưa chọn file.');
    }
  }

  const renderImportExcel = () => {
    return (
      <Dialog header="Nhập dữ liệu từ Excel" visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-12">
            <label htmlFor="file">Chọn file</label>
            <input ref={input} id="file" type="file" accept=".xlsx, .xls" onChange={onUploadExcelFile}/>
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Tải file mẫu" icon="pi pi-file-excel" onClick={downloadTemplate} loading={submitting} className="p-button-sm p-button-help mr-2"/>
          <Button label="Nhận file" icon="pi pi-upload" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderImportExcel, showImportDialog};

}